import { nToWord } from '@/utils/helpers'

const maxDuration = 28

const durations = Array(maxDuration)
  .fill({})
  .map((x, i) => ({
    slug: i + 1,
    name: `${i + 1} ${nToWord(i + 1, ['ночь', 'ночи', 'ночей'])}`
  }))

export default durations